import { createAction, props } from '@ngrx/store';
import { ContainerActivity } from '../_models';

// Action types
export const loadContainerActivities = createAction('[ContainerActivity] Load ContainerActivities');
export const loadContainerActivitiesSuccess = createAction(
  '[ContainerActivity] Load ContainerActivities Success',
  props<{ containerActivities: ContainerActivity[] }>()
);
export const loadContainerActivitiesFailure = createAction(
  '[ContainerActivity] Load ContainerActivities Failure',
  props<{ error: any }>()
);

export const addContainerActivity = createAction(
  '[ContainerActivity] Add ContainerActivity',
  props<{ containerActivity: ContainerActivity }>()
);
export const addContainerActivitySuccess = createAction(
  '[ContainerActivity] Add ContainerActivity Success',
  props<{ containerActivity: ContainerActivity }>()
);
export const addContainerActivityFailure = createAction(
  '[ContainerActivity] Add ContainerActivity Failure',
  props<{ error: any }>()
);

export const updateContainerActivity = createAction(
  '[ContainerActivity] Update ContainerActivity',
  props<{ containerActivity: ContainerActivity }>()
);
export const updateContainerActivitySuccess = createAction(
  '[ContainerActivity] Update ContainerActivity Success',
  props<{ containerActivity: ContainerActivity }>()
);
export const updateContainerActivityFailure = createAction(
  '[ContainerActivity] Update ContainerActivity Failure',
  props<{ error: any }>()
);

export const deleteContainerActivity = createAction(
  '[ContainerActivity] Delete ContainerActivity',
  props<{ id: number }>()
);
export const deleteContainerActivitySuccess = createAction(
  '[ContainerActivity] Delete ContainerActivity Success',
  props<{ id: number }>()
);
export const deleteContainerActivityFailure = createAction(
  '[ContainerActivity] Delete ContainerActivity Failure',
  props<{ error: any }>()
);
